module.exports = __webpack_public_path__ + "img/git.f4f5f8c4.svg";